import request from "axios";
import queryString from "query-string";
import { browserHistory } from "react-router";
import { PROJECTS_RESOURCE_NAME, TABS_MAP } from "your_projects/constants";
import { getAPIQueryString } from "common/utils";
import { savePageCount } from "common/pager/ducks";
import { setBannerError } from "error";
import { getValueFromQuery } from "common/filter/utils";
import { TYPE_CHECKBOXES } from "common/filter/constants";
import merge from "lodash/merge";

/* ACTIONS
================================================================================================ */
const FETCH = "your_projects/FETCH";
const FETCH_REQUEST = "your_projects/FETCH_REQUEST";
const FETCH_SUCCESS = "your_projects/FETCH_SUCCESS";

const FETCH_COUNTS_SUCCESS = "your_projects/FETCH_COUNTS_SUCCESS";

const CLEAR = "your_projects/CLEAR";

const TOGGLE_REMOVE_DRAFT = "your_projects/TOGGLE_REMOVE_DRAFT";

/* HELPERS
================================================================================================ */

/* INITIAL STATES
================================================================================================ */
export const initialState = {
  list: [],
  isFetching: false,
  counts: { client: {}, creative: {} },
  removingDraft: null,
};

/* REDUCERS
================================================================================================ */
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        list: [],
      };
    case FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload.results,
        counts: {
          ...state.counts,
          [action.userType]: {
            ...state.counts[action.userType],
            [action.projectType]: action.payload.count,
          },
        },
      };
    case CLEAR:
      return {
        ...state,
        list: [],
      };
    case FETCH_COUNTS_SUCCESS:
      return {
        ...state,
        counts: merge({}, state.counts, action.payload),
      };
    case TOGGLE_REMOVE_DRAFT:
      return {
        ...state,
        removingDraft: action.payload,
      };
    default:
      return state;
  }
}

export const fetch = (userType, projectType, query) => (dispatch) => {
  const { apiUrl, apiParams } = TABS_MAP[userType][projectType];
  /* override status filter if specified */
  const overridenStatus = getValueFromQuery(
    PROJECTS_RESOURCE_NAME,
    "filter_status",
    TYPE_CHECKBOXES,
    query
  );
  const params =
    overridenStatus.length > 0
      ? {
          ...apiParams,
          filter_status: undefined,
          status: overridenStatus,
        }
      : apiParams;

  const queryStr = getAPIQueryString(PROJECTS_RESOURCE_NAME, query, {
    extraAPIQuery: params,
  });
  const promise = request.get(`${apiUrl}?${queryStr}`);

  /* save page count in pager state */
  promise.then((res) => dispatch(savePageCount(PROJECTS_RESOURCE_NAME, res)));

  return dispatch({
    type: FETCH,
    promise,
    userType,
    projectType,
  });
};

export const clear = () => {
  return {
    type: CLEAR,
  };
};

export const fetchCounts =
  (activeUserType, activeProjectType) => (dispatch, getState) => {
    const user = getState().user.profile_data;
    const counts = { client: {}, creative: {} };

    let counters = ["client", "creative"].reduce((acc, userType) => {
      let userTypeCounters;

      if (!user[`is_${userType}`]) {
        userTypeCounters = [];
      } else {
        userTypeCounters = Object.keys(TABS_MAP[userType]).map(
          (projectType) => {
            const { apiParams, apiUrl } = TABS_MAP[userType][projectType];

            return {
              requestUrl: `${apiUrl}?${queryString.stringify(apiParams)}`,
              projectType,
              userType,
            };
          }
        );
      }

      return acc.concat(userTypeCounters);
    }, []);

    /* don't fetch count for active `userType` and `projectType`, since it will be
     provided along with the project list */
    counters = counters.filter(
      (c) =>
        !(c.userType === activeUserType && c.projectType === activeProjectType)
    );

    counters.reduce((acc, counter, i) => {
      return acc.then(() => {
        return request.get(counter.requestUrl).then((res) => {
          counts[counter.userType][counter.projectType] = res.data.count;
          if (i === counters.length - 1) {
            dispatch({
              type: FETCH_COUNTS_SUCCESS,
              payload: counts,
            });
          }
        });
      });
    }, Promise.resolve());
  };

export const toggleRemoveDraft = (draft) => ({
  type: TOGGLE_REMOVE_DRAFT,
  payload: draft,
});

export const removeDraft = () => (dispatch, getState) => {
  const { removingDraft } = getState().yourProjects;

  return request
    .delete(`/api/v1/projects/${removingDraft.id}/`)
    .then(() => {
      dispatch(toggleRemoveDraft(null));
      /* Give the backend (Elastic Search) 2s to reflect the changes before drafts are
       fetched again. */
      setTimeout(
        () => browserHistory.push("/your-projects/client/drafts/"),
        2000
      );
    })
    .catch(() =>
      dispatch(setBannerError("Error removing draft", "Please try again."))
    );
};
